import React from 'react'

export default function About() {
    return (
        <section id="about" className="text-center">
            <h1>About</h1>
            <div className="about">
                <div className="about-content">
                    <p>Hey there! 👋 I'm Anmol, a passionate website maker and freelance enthusiast. As a first-year IT
                        engineering student, I've dived headfirst into the world of web development.
                    </p>

                    <p>💡 Why Websites?</p>
                    <p>
                        I love turning ideas into digital experiences. From sleek designs to functional websites, I
                        thrive on bringing visions to life in the online realm.
                    </p>

                    <p>🚀 Freelance Journey</p>
                    <p>
                        Currently juggling studies and freelancing, I've collaborated on diverse projects, adding my
                        touch to the web. I believe in the power of simplicity, clean code, and creating websites that
                        speak for themselves.
                    </p>

                    <p>🛠️ Tech Toolkit</p>
                    <p>
                        Proficient in HTML, CSS, and JavaScript, I leverage these tools to craft user-friendly, visually
                        appealing websites. I'm all about the perfect blend of form and function.
                    </p>

                    <p>🌐 Future Forward</p>
                    <p>
                        Excited about the endless possibilities in the digital landscape, I'm not just building
                        websites; I'm crafting online experiences that make an impact. Let's connect and bring your
                        digital dreams to life!
                    </p>
                </div>
            </div>
        </section>

    )
}
